var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAni2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 21V10.9999M10 10.9999L18.73 5.95992M10 10.9999L1.27 5.95992M19 15.008V6.98993C18.9994 6.64099 18.9066 6.29842 18.731 5.9969C18.5554 5.69538 18.3032 5.44562 18 5.27292L11 1.26489C10.6953 1.09129 10.3507 1 10 1C9.64932 1 9.30469 1.09129 9 1.26489L2 5.27292C1.381 5.62792 1 6.28292 1 6.99093V15.009C1 15.718 1.381 16.372 2 16.726L9 20.734C9.30469 20.9076 9.64932 20.9989 10 20.9989C10.3507 20.9989 10.6953 20.9076 11 20.734L18 16.726C18.619 16.371 19 15.716 19 15.008Z",
    stroke: "#D9D9D9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAni2);
export default __webpack_public_path__ + "static/media/Ani2.7938f11a778e6d9caa7bc5a89613e96f.svg";
export { ForwardRef as ReactComponent };